(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heatpress-anatomy"] && !Shopify.designMode) return;
  try {
    
(function () {

  var els = document.querySelectorAll('.hp-anatomy');

  function startCycle(el) {

    if (el.dataset.started) return;
    el.dataset.started = 'true';

    function cycle() {

      // PRESS DOWN
      el.classList.add('is-in');

      // HOLD PRESS DOWN 4s
      setTimeout(function () {

        // PRESS UP
        el.classList.remove('is-in');

        // wait for platen to rise
        setTimeout(function () {

          // old transfer exits left
          el.classList.add('film-out');

          setTimeout(function () {

            // reset offscreen right
            el.classList.remove('film-out');
            el.classList.add('film-reset');

            // force reflow
            void el.offsetWidth;

            // slide new film in
            el.classList.add('film-in');
            el.classList.remove('film-reset');

            setTimeout(function () {

              // cleanup
              el.classList.remove('film-in');

            }, 900);

          }, 800);

        }, 1200);

      }, 4000);

    }

    cycle();

    setInterval(cycle, 6000);
  }

  if (!('IntersectionObserver' in window)) {
    els.forEach(startCycle);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {

      if (entry.isIntersecting) {
        startCycle(entry.target);
      }

    });
  }, { threshold: 0.2 });

  els.forEach(function (el) {
    io.observe(el);
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heatpress-dtf"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var els = document.querySelectorAll('.hp-dtf');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.18 });
    els.forEach(function (e) { io.observe(e); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heatpress-prologue"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.hp-prologue');
    if (!('IntersectionObserver' in window) || !sections.length) {
      sections.forEach(function (s) { s.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    sections.forEach(function (s) { io.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-vitals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.mp-vital').forEach(function(v){ v.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.mp-vital').forEach(function(v){ io.observe(v); });
  })();

  } catch(e) { console.error(e); }
})();
})();
